var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"padding-10"},[_c('Toolbar'),_c('FilterBar'),_c('Table')],1)}
var staticRenderFns = []

export { render, staticRenderFns }